import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Caixa } from 'src/app/admihair/api/dto/caixa';
import { CaixaService } from 'src/app/admihair/service/caixa.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { SelectItem } from 'primeng/api';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';
import { ResumoCaixaGerenciar } from 'src/app/admihair/api/dto/resumo-caixa-gerenciar';
import { OverlayPanel } from 'primeng/overlaypanel';
import { DetalharContaCaixaGerenciar } from 'src/app/admihair/api/dto/detalhar-conta-caixa-gerenciar';
import { DetalharComandaGerenciar } from 'src/app/admihair/api/dto/detalhar-comanda-gerenciar';
import { RelatorioCaixaTotalComanda } from 'src/app/admihair/api/dto/relatorio-caixa-total-comanda';
import { RelatorioCaixaService } from 'src/app/admihair/service/relatorio-caixa.service';
import { DespesaCaixaGerenciar } from 'src/app/admihair/api/dto/despesa-caixa-gerenciar';
import { RelatorioTransferenciaCaixa } from 'src/app/admihair/api/dto/relatorio-transferencia-caixa';

@Component({
  selector: 'app-caixa-gerenciar-detalhar',
  templateUrl: './caixa-gerenciar-detalhar.component.html',
  styleUrls: ['./caixa-gerenciar-detalhar.component.scss']
})
export class CaixaGerenciarDetalharComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  loadingTable: boolean = true;
  id?: number;
  caixa?: Caixa;
  listaComandas: RelatorioCaixaTotalComanda[] = [];
  inputBusca: string = '';
  listaSitucoesStatus: SelectItem[] = [
    { label: 'TODAS', value: 'TODAS' },
    { label: 'ABERTAS', value: 'ABERTA' },
    { label: 'FECHADAS', value: 'FECHADA' }
  ];
  statusComandaSelecionado: string = 'TODAS';

  usuariosSelectItem: SelectItem[] = [{ label: 'TODOS', value: null }];
  usuarioSelecionado?: Usuario;

  valorTotalCaixa: number = 0;
  resumoCaixa?: ResumoCaixaGerenciar;
  porcentagemComandaFechadas: string = '';
  porcentagemContaCaixa: string = '';
  porcentagemContaBanco: string = '';
  porcentagemContaAjuste: string = '';

  exibirSpinnerDetalhes: boolean = false;
  detalhesConta: DetalharContaCaixaGerenciar[] = [];
  detalhesComanda: DetalharComandaGerenciar[] = [];
  valorTotalDetalheConta: number = 0;

  listaDespesasCaixa: DespesaCaixaGerenciar[] = [];
  loadingTableDespesas: boolean = false;
  totalDespesas: number = 0;

  listaTransferenciasCaixa: RelatorioTransferenciaCaixa[] = [];
  loadingTableTransferencias: boolean = false;
  totalTransferencias: number = 0;

  constructor(private caixaService: CaixaService,
    private relatorioCaixaService: RelatorioCaixaService,
    private usuarioService: UsuarioService,
    private activatedRouter: ActivatedRoute,
    erroService: ErroService,
    storageService: UtilStorageService) {
    super(erroService, storageService)
  }

  ngOnInit(): void {
    this.setExibirSpinnerPrincipal(true);
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_GERENCIAR_CAIXA');
    this.carregarId();
    this.carregarCaixa();
  }

  carregarCaixa() {
    this.caixaService.buscarPorId(this.id).subscribe({
      next: (data: Caixa) => {
        this.caixa = data;
        this.listarResumoCaixa();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  listarResumoCaixa() {
    this.caixaService.listarResumoCaixa(this.getEmpresa().id, this.caixa?.dataCaixa).subscribe({
      next: (data: ResumoCaixaGerenciar) => {
        this.resumoCaixa = data;

        if (data.quantidadeComandaFechada && data.quantidadeTotalComanda) {
          this.porcentagemComandaFechadas =
            ((data.quantidadeComandaFechada / data.quantidadeTotalComanda) * 100).toFixed(2);
        } else {
          this.porcentagemComandaFechadas = '0.00';
        }
        this.calcularPorcentagensContas();
        this.listarUsuariosCaixa();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err)
      }
    })
  }

  listarUsuariosCaixa() {
    this.usuarioService.listarPorEmpresaEDataCaixa(this.getEmpresa().id, this.caixa?.dataCaixa).subscribe({
      next: (data: Usuario[]) => {
        data.forEach(usuario => this.usuariosSelectItem.push({ label: usuario.apelido, value: usuario }));
        this.listarRelatorioComandas();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err)
      }
    })
  }

  listarRelatorioComandas() {
    this.loadingTable = true;
    this.relatorioCaixaService.consultarRelotorioTotaisComanda(this.getEmpresa().id,
      this.caixa?.dataCaixa, this.statusComandaSelecionado, this.usuarioSelecionado?.id,
      this.inputBusca)
      .subscribe({
        next: (data: RelatorioCaixaTotalComanda[]) => {
          this.listaComandas = data;
          this.loadingTable = false;
          this.listarDespesasCaixa();

        },
        error: (err: any) => {
          this.loadingTable = false;
          this.setExibirSpinnerPrincipal(false);
          this.exibirMensagemErro(err);
        }
      })
  }

  listarDespesasCaixa() {
    this.caixaService.listarDespesasCaixa(this.getEmpresa().id, this.caixa?.dataCaixa).subscribe({
      next: (data: DespesaCaixaGerenciar[]) => {
        this.listaDespesasCaixa = data;
        this.calcularTotalDespesas();
        this.listarTransferenciasCaixa();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  listarTransferenciasCaixa() {
    this.caixaService.listarTransferenciasCaixa(this.getEmpresa().id, this.caixa?.dataCaixa).subscribe({
      next: (data: RelatorioTransferenciaCaixa[]) => {
        this.listaTransferenciasCaixa = data;
        this.calcularTotalTransferencias();
        this.setExibirSpinnerPrincipal(false);
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  calcularTotalTransferencias() {
    for(const transferencia of this.listaTransferenciasCaixa) {
      this.totalTransferencias = this.totalTransferencias + (transferencia.valor ?? 0);
    }
  }

  calcularTotalDespesas() {
    for(const despesa of this.listaDespesasCaixa) {
      this.totalDespesas = this.totalDespesas + (despesa.valor ?? 0);
    }
  }

  carregarDetalharConta(event: any, overlay: OverlayPanel, tipoConta: string) {
    overlay.toggle(event);
    this.exibirSpinnerDetalhes = true;
    this.caixaService.consultarDetalhesPagamentoPorTipoContaEData(this.getEmpresa().id,
      this.caixa?.dataCaixa, tipoConta).subscribe({
        next: (data: DetalharContaCaixaGerenciar[]) => {
          this.detalhesConta = data;
          this.calcularValorTotalDetalheConta();
          this.exibirSpinnerDetalhes = false;

        },
        error: (err: any) => {
          this.exibirSpinnerDetalhes = false;
          this.exibirMensagemErro(err)
        }
      })

  }

  calcularValorTotalDetalheConta() {
    this.valorTotalDetalheConta = 0;
    for (const item of this.detalhesConta) {
      if (item.valor) {
        this.valorTotalDetalheConta = this.valorTotalDetalheConta + item.valor;
      }
    }
  }

  carregarDetalharComanda(event: any, overlay: OverlayPanel) {
    overlay.toggle(event);
    this.exibirSpinnerDetalhes = true;
    this.caixaService.consultarDetalhesComandaPorEmpresaEDataCaixa(this.getEmpresa().id,
      this.caixa?.dataCaixa).subscribe({
        next: (data: DetalharComandaGerenciar[]) => {
          this.detalhesComanda = data;
          this.exibirSpinnerDetalhes = false;
        },
        error: (err: any) => {
          this.exibirSpinnerDetalhes = false;
          this.exibirMensagemErro(err)
        }
      });
  }

  calcularPorcentagensContas() {
    this.valorTotalCaixa = 0;

    if (this.resumoCaixa) {
      const valorContaCaixa = this.resumoCaixa.valorTotalContaCaixa ?? 0;
      const valorContaBanco = this.resumoCaixa.valorTotalContaBanco ?? 0;
      const valorContaAjuste = this.resumoCaixa.valorTotalContaAjuste ?? 0;

      this.valorTotalCaixa = valorContaCaixa + valorContaBanco + valorContaAjuste;

      if (this.valorTotalCaixa > 0) {
        this.porcentagemContaCaixa = ((valorContaCaixa / this.valorTotalCaixa) * 100).toFixed(2);
        this.porcentagemContaBanco = ((valorContaBanco / this.valorTotalCaixa) * 100).toFixed(2);
        this.porcentagemContaAjuste = ((valorContaAjuste / this.valorTotalCaixa) * 100).toFixed(2);
      } else {
        this.porcentagemContaCaixa = "0.00";
        this.porcentagemContaBanco = "0.00";
        this.porcentagemContaAjuste = "0.00";
      }
    } else {
      this.porcentagemContaCaixa = "0.00";
      this.porcentagemContaBanco = "0.00";
      this.porcentagemContaAjuste = "0.00";
    }
  }

  buscar(event: Event) {
    this.inputBusca = (event.target as HTMLInputElement).value;
    this.listarRelatorioComandas();
  }

  limpar() {
    this.filter.nativeElement.value = '';
    this.inputBusca = '';
    this.statusComandaSelecionado = 'TODAS';
    this.listarRelatorioComandas();
  }

  carregarId() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }

  }

  openComandaResumo(comandaId?: number) {
    const width = window.innerWidth * 0.4;
    const height = window.innerHeight * 0.4;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;

    const url = `${window.location.origin}/#/janela-empresa/comanda/${comandaId}`;
    const newWindow = window.open(
      url,
      '_blank',
      `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no`
    );

    newWindow?.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        newWindow.close();
      }
    });
    newWindow?.addEventListener('load', () => {
      newWindow.document.body.style.overflowX = 'hidden';
    });
  }

}
